export default "__VITE_ASSET__DQu2yrUy__"